import React, { useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import AcademicHeader from "./AcademicHeader";
import { LoadingDiv } from "../master/Master";

const Gallery = () => {
  const [loading, setLoading] = useState(false);
  const [photos, setPhotos] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);

  // Handle file upload
  const handleUpload = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    setLoading(true);
    setTimeout(() => {
      const uploadedPhotos = files.map((file) => ({
        id: Date.now() + Math.random(),
        name: file.name,
        url: URL.createObjectURL(file), // Temporary local preview URL
        file,
      }));
      setPhotos((prev) => [...prev, ...uploadedPhotos]);
      setLoading(false);
    }, 800);
  };

  // Handle delete photo
  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this photo?")) {
      setPhotos((prev) => prev.filter((photo) => photo.id !== id));
    }
  };

  // Handle download
  const handleDownload = (photo) => {
    const link = document.createElement("a");
    link.href = photo.url;
    link.download = photo.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />

            <div className="container-fluid">
              <div className="row">
                <AcademicHeader />
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h3>Photo Gallery</h3>
                        <label className="btn btn-primary mb-0">
                          + Upload Photos
                          <input
                            type="file"
                            multiple
                            accept="image/*"
                            hidden
                            onChange={handleUpload}
                          />
                        </label>
                      </div>

                      {/* Gallery Grid */}
                      {photos.length === 0 ? (
                        <p className="text-muted text-center">
                          No photos uploaded yet.
                        </p>
                      ) : (
                        <div className="row g-3">
                          {photos.map((photo) => (
                            <div
                              key={photo.id}
                              className="col-6 col-md-4 col-lg-3"
                            >
                              <div className="card shadow-sm position-relative">
                                <img
                                  src={photo.url}
                                  alt={photo.name}
                                  className="card-img-top"
                                  style={{
                                    height: "200px",
                                    objectFit: "cover",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => setPreviewImage(photo.url)}
                                />
                                <div className="card-body text-center p-2">
                                  <small className="text-truncate d-block">
                                    {photo.name}
                                  </small>
                                  <div className="d-flex justify-content-center gap-2 mt-2">
                                    <button
                                      className="btn btn-sm btn-outline-primary"
                                      onClick={() => handleDownload(photo)}
                                    >
                                      <i className="bi bi-download"></i>{" "}
                                      Download
                                    </button>
                                    <button
                                      className="btn btn-sm btn-outline-danger"
                                      onClick={() => handleDelete(photo.id)}
                                    >
                                      <i className="bi bi-trash"></i> Delete
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Preview Modal */}
      {previewImage && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.8)" }}
          onClick={() => setPreviewImage(null)}
        >
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <img
              src={previewImage}
              alt="Preview"
              style={{
                maxHeight: "90%",
                maxWidth: "90%",
                borderRadius: "8px",
                boxShadow: "0 0 20px rgba(255,255,255,0.2)",
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;
